import {
  FETCH_REPORTES_TERMINAL,
  FETCH_TIPO_REPORTES,
  REGISTRA_REPORTE,
  FILTRA_REPORTES_PISTOLAS,
  CLEAR_DATA_REPORTES_PISTOLAS,
  FETCH_ULTIMO_REPORTE_PISTOLA,
} from "../actions/types";

const INITIAL_STATE = {
  reportePistolas: [],
  reportePistolasOriginal: [],
  reporteTipos: [],
  utlimoReporte: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_REPORTES_TERMINAL:
      return {
        ...state,
        reportePistolas: action.payload,
        reportePistolasOriginal: action.payload,
      };
    case FILTRA_REPORTES_PISTOLAS:
      return {
        ...state,
        reportePistolas: action.payload,
      };
    case REGISTRA_REPORTE:
      return {
        ...state,
      };
    case FETCH_TIPO_REPORTES:
      return {
        ...state,
        reporteTipos: action.payload,
      };
    case FETCH_ULTIMO_REPORTE_PISTOLA:
      return {
        ...state,
        utlimoReporte: action.payload,
      };
    case CLEAR_DATA_REPORTES_PISTOLAS:
      return INITIAL_STATE;
    default:
      return state;
  }
};
